module.exports = __webpack_public_path__ + "static/img/9.e8368515.png";